import { Navigate, useLocation } from 'react-router-dom';
import { evaluationsTabTarget } from '../pages/custom-agents/customAgentsRoutes';

/**
 * Model evaluations were the Agent Registry's Evaluations tab; they are their own section now
 * (Custom Agents → Assessment → Model Evaluation). `?tab=evaluations` on /custom-agents/registry
 * or /admin/agents forwards there with the other query params and hash kept; any other URL
 * renders `children`.
 */
const ForwardEvaluationsTab = ({ children }) => {
  const target = evaluationsTabTarget(useLocation());
  return target ? <Navigate to={target} replace /> : children;
};

export default ForwardEvaluationsTab;
